document.addEventListener('DOMContentLoaded', function () {

  const textarea = document.querySelector(
    'textarea[name="contact[complaint_description]"]'
  );

  if (textarea) {

    textarea.addEventListener('input', function () {

      if (this.value.length > 1000) {
        this.value = this.value.substring(0, 1000);
      }

    });

  }

});